<template>
  <div class="ticket-detail-content-wrapper">
    <div v-if="!value.ticket" class="skeleton-wrapper">
      <van-skeleton :row="5" title />
    </div>
    <div v-else>
      <van-panel :title="value.ticket">
        <display-field label="价格" :value="`￥${value.price || 0}`" highlight />

        <field-option-tel-input
          v-if="value.message_mobile !== 0"
          @change="tel => handleFieldChange('tel', tel)"
        />

        <!-- <field-option-shop-picker
          :items="value.channel || []"
          @change="shop => handleFieldChange('shop', shop)"
        /> -->

        <field-option-date-picker
          v-if="value.can_book_time"
          :items="value.can_book_time || []"
          @change="date => handleFieldChange('date', date)"
        />

        <field-option-interval-picker
          v-show="time_intervals.length"
          :items="time_intervals"
          @change="interval => handleFieldChange('interval', interval)"
        />

        <field-option-count-input
          :left="value.left"
          ref="count-input"
          @change="count => handleFieldChange('count', count)"
        />

        <field-option-customer-info-group
          v-if="value.message_name !== 0"
          :items="form.info"
          @change="info => handleFieldChange('info', info)"
          :isShowFace="value.message_face"
        />

        <div
          class="van-hairline--top-bottom imgs"
          v-if="value.message_name === 0 && value.message_face"
        >
          <div v-for="(_, index) in form.count" :key="index">
            <p style="padding:10px 0">人脸识别</p>
            <field-choose-images
              v-if="value.message_name === 0 && value.message_face"
              @change="imgs => handleFieldChange('image', imgs, index)"
            />
          </div>
        </div>
      </van-panel>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DisplayField from '@/components/DisplayField.vue';
import FieldOptionTelInput from '@/components/FieldOptionTelInput.vue';
// import FieldOptionShopPicker from '@/components/FieldOptionShopPicker.vue';
import FieldOptionDatePicker from '@/components/FieldOptionDatePicker.vue';
import FieldOptionIntervalPicker from '@/components/FieldOptionIntervalPicker.vue';
import FieldOptionCountInput from '@/components/FieldOptionCountInput';
import FieldOptionCustomerInfoGroup from '@/components/FieldOptionCustomerInfoGroup.vue';
import FieldChooseImages from '@/components/FieldChooseImages.vue';

export default {
  components: {
    DisplayField,
    FieldOptionTelInput,
    // FieldOptionShopPicker,
    FieldOptionDatePicker,
    FieldOptionIntervalPicker,
    FieldOptionCountInput,
    FieldOptionCustomerInfoGroup,
    FieldChooseImages,
  },
  props: {
    value: [Object],
    united: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      time_intervals: [],
      form: {
        tel: '',
        date: '',
        interval: '',
        shop: '',
        count: 1,
        info: [
          {
            name: '',
            identityNo: '',
            img: '',
          },
        ],
        image: [],
      },
    };
  },
  computed: {
    ...mapGetters(['appPlatform']),
  },
  methods: {
    handleFieldChange(key, value, index) {
      let val = value;
      // if (['date', 'interval'].includes(key)) {
      //   if (this.$refs['count-input']) this.$refs['count-input'].resetCount();
      // }
      let { info } = this.form;
      if (key === 'date') {
        this.time_intervals = val.times;
        val = value.date;
        this.$emit('count', value.count);
      }
      if (key === 'interval') {
        val = value.id;
        this.$emit('count', value.count);
      }
      if (key === 'count') {
        if (val < info.length) {
          info = info.slice(0, val);
        } else {
          info = [
            ...info,
            ...Array.from({ length: val - info.length }, () => ({
              name: '',
              identityNo: '',
              img: '',
            })),
          ];
        }
      }
      // 非实名制下 人脸识别
      if (key === 'image') {
        val = this.form.image.map((item, k) => {
          if (index === k) {
            return val;
          }
          return item;
        });
      }
      this.form = { ...this.form, info, [key]: val };
      this.$emit('change', this.form);
    },
  },
};
</script>
<style lang="less" scoped>
.ticket-detail-content-wrapper {
  // padding-right: 16px;
  .skeleton-wrapper {
    padding-top: 16px;
  }
  .van-panel__header .van-cell__title {
    padding: 4px 0;
    font-size: 140%;
  }
  .absolute-right {
    position: absolute;
    right: 0;
    top: 0;
    width: 16px;
    height: 100%;
    background: #fff;
  }
  .imgs {
    margin: 0 16px;
    padding-bottom: 10px;
  }
}
</style>
